import React from 'react';
import { FaClipboardList, FaDollarSign, FaRocket } from 'react-icons/fa';
import { Link } from "react-router-dom";
import NpsnLogo from '../../assets/npsn_logo.png';
import Header from './Header.js';
import Footer from './Footer.js';


const TermsAndConditions = () => {
  const contactEmail = 'support@intelserve.io';

  return (
<>
<Header appName="IntelServe" />
    <div className="max-w-4xl mx-auto p-8 md:p-12 bg-white ">
      <div className="mb-8 border-b pb-4">
        <h1 className="text-4xl font-extrabold text-gray-600 flex items-center">
          <FaClipboardList className="mr-3 text-gray-500" />
          Terms and Conditions
        </h1>
        <p className="mt-2 text-gray-500">
          Effective Date: October 18, 2025
        </p>
      </div>

      <section className="space-y-6">
        <h2 className="text-2xl font-semibold text-gray-800">1. Acceptance of Terms</h2>
        <p className="text-gray-600">
          By accessing or using the IntelServe platform ("Service"), you agree to be bound by these Terms and Conditions ("Terms"). If you disagree with any part of the terms, then you may not access the Service.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 flex items-center">
          <FaRocket className="mr-2 text-green-500" />
          2. Service Use and Scope
        </h2>
        <p className="text-gray-600">
          IntelServe provides a cloud-based case management solution for legal process serving and related services. You agree to use the Service only for lawful purposes related to your professional practice. You are responsible for the legal compliance of all data, including any GPS location data, videos, or legal documents uploaded or generated via the Service.
        </p>
        
        <h2 className="text-2xl font-semibold text-gray-800 flex items-center">
          <FaDollarSign className="mr-2 text-yellow-500" />
          3. Subscription and Billing
        </h2>
        <ul className="list-disc list-inside space-y-2 ml-4 text-gray-600">
          <li><b>Billing Cycles:</b> All subscription fees for the Standard, Pro, and Elite plans are billed on a recurring, periodic basis (monthly or annually).</li>
          <li><b>Cancellations:</b> You may cancel your subscription at any time. Your subscription access will remain active until the end of the current billing period, and you will not be charged again. Refunds are generally not provided for partially used subscription periods.</li>
          <li><b>Price Changes:</b> IntelServe reserves the right to change its subscription fees upon 30 days prior notice.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800">4. Limitation of Liability</h2>
        <p className="text-gray-600">
          IntelServe acts as a software provider and is not a law firm or process server. We are not responsible for the successful execution of service of process or any legal outcomes resulting from your use of the Service.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800">5. Contact Information</h2>
        <p className="text-gray-600">
          For any questions regarding these Terms, please contact us at: <a href={`mailto:${contactEmail}`} className="text-blue-600 hover:underline"><b>{contactEmail}</b></a>.
        </p>
      </section>
    </div>

<Footer NpsnLogo={NpsnLogo} />
</>
  );
};

export default TermsAndConditions;